/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { notificarErroApi } from "utils/alertaCiencia";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idLeadCorretor: string;
  idUnidade: string;
  anexo: {
    base64: string;
    fileName: string;
  };
}

export function useCadastrarPropostaManual() {
  const postData = async (props: Props) => {
    const URL = `${backofficeEnviroment}/common/oportunidades-lead/cadastrar-proposta-manual/vivaz/v1`;
    const { data } = await instance.post(URL, {
      idLeadCorretor: props.idLeadCorretor,
      idUnidade: props.idUnidade,
      anexo: props.anexo,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("Proposta manual cadastrada com sucesso!");
    },
    onError: (error: any) => {
      notificarErroApi("Erro ao cadastrar proposta manual", error);
    },
  });

  return mutation;
}
